<template>
  <div style="display: flex; margin: 30px; flex-direction: column">
    <div
      style="
        margin: 10px;
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      "
    >
      <div>
        <h1 style="font-size: 20px">{{ $t("_liste_des_installations_") }}</h1>
      </div>
      <div style="display: flex; gap: 20px">
        <div>
          <v-btn
            @click="toggleButton('btnNettoyage')"
            :color="activeButton === 1 ? 'orange' : undefined"
          >
            {{ $t("_nettoyage_") }}
          </v-btn>
        </div>
        <div>
          <v-btn
            @click="toggleButton('btnElagage')"
            :color="activeButton === 2 ? 'orange' : undefined"
          >
            {{ $t("_elagage_") }}
          </v-btn>
        </div>
      </div>
    </div>
    <div>
      <v-data-table
        :headers="takeheader()"
        :items="liste_fleet"
        class="custom-data-table"
        :footer-props="{
          'items-per-page-options': [20, 50, 100, -1],
          'items-per-page-text': this.$t('_lignes_par_page_'),
        }"
        style="width: 100%"
      >
        <template v-slot:body="{ items }">
          <tbody>
            <tr
              v-for="item in items"
              :key="item.id"
              :class="{ disabled: item.is_forbidden }"
            >
              <td
                v-for="column in takeheader()"
                :key="column.value"
                :style="{ cursor: 'pointer' }"
                @click="goToInstallation(item)"
              >
                {{ item[column.value] }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </div>
    <!-- <v-btn style="margin: 10px; margin-left: -20px; width: 300px;">{{ $t("_telecharger_le_tableau_comparatif_") }}</v-btn>-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    selectsite: {
      type: Array,
      required: true,
    },
    liste_fleet: { type: Array, default: () => [] },
    selected_date: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      btnNettoyage: JSON.parse(localStorage.getItem("btnNettoyage")) || false,
      btnElagage: JSON.parse(localStorage.getItem("btnElagage")) || false,
      chooseheader: [],
      start_date: "",
      end_date: "",
      activeButton: 0,
    };
  },
  mounted() {
    this.toggleButton("btnNettoyage");
  },
  watch: {
    "$root.$i18n.locale": {
      async handler() {
        await this.refresh_header_values();
        await this.takeheader();
        await this.toggleButton("btnNettoyage");
      },
      immediate: true,
    },
    $route: {
      async handler() {
        await this.refresh_header_values();
        await this.takeheader();
        await this.toggleButton("btnNettoyage");
      },
      immediate: true,
    },
    selected_date: {
      async handler() {
        await this.refresh_header_values();
        await this.takeheader();
        await this.toggleButton("btnNettoyage");
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(["role", "cur_install_id", "constants", "installations"]),
  },

  methods: {
    refresh_header_values() {
      this.chooseheader = [
        { text: this.$t("_site_"), value: "installation_name" },
        { text: this.$t("_puissance_crete_(kwc)_"), value: "pc_totale" },
        { text: this.$t("_adresse_"), value: "city", value_two: "country" },
        {
          text: this.$t("_company_name_"),
          value: "company_name",
        },
        {
          text: this.$t("_groupe_"),
          value: "groupe",
        },
        {
          text: this.$t("_type_d_installation_inclinaison_orientation_"),
          value: "installation_type",
        },
        { text: this.$t("_mise_en_service_"), value: "start_date" },
        { text: this.$t("_site_last_update_"), value: "site_last_update" },
      ];
    },
    toggleButton(button) {
      if (button === "btnNettoyage") {
        this.btnNettoyage = true;
        this.btnElagage = false;
        this.activeButton = 1;
      } else if (button === "btnElagage") {
        this.btnNettoyage = false;
        this.btnElagage = true;
        this.activeButton = 2;
      }

      localStorage.setItem("btnNettoyage", JSON.stringify(this.btnNettoyage));
      localStorage.setItem("btnElagage", JSON.stringify(this.btnElagage));
    },

    isButtonDisabled(button) {
      if (button === "btnNettoyage") {
        return this.btnElagage;
      } else if (button === "btnElagage") {
        return this.btnNettoyage;
      }
      return false;
    },

    takeheader() {
      let dynamicHeaders = [...this.chooseheader];

      if (
        this.btnNettoyage &&
        !dynamicHeaders.some((header) => header.text === "nettoyage")
      ) {
        dynamicHeaders.push({
          text: this.$t("_site_last_cleaning_dates_"),
          value: "site_last_cleaning_dates", // ensure this key is added if returned by your backend/query
        });
        dynamicHeaders.push({
          text: this.$t("_site_current_soiling_losses_pct_"),
          value: "site_current_soiling_losses_pct",
        });
        dynamicHeaders.push({
          text: this.$t("_soiling_losses_compliance_"),
          value: "soiling_losses_compliance",
        });
    
        dynamicHeaders.push({
          text: this.$t("_site_cleaning_freq_initial_"),
          value: "site_cleaning_freq_initial",
        });
        dynamicHeaders.push({
          text: this.$t("_site_cleaning_freq_chosen_"),
          value: "site_cleaning_freq_chosen",
        });
        dynamicHeaders.push({
          text: this.$t("_roi_cleaning_euro_user_long_"),
          value: "roi_cleaning_euro_user_long",
        });
        dynamicHeaders.push({
          text: this.$t("_site_cleaning_freq_optim_"),
          value: "site_cleaning_freq_optim",
        });
        dynamicHeaders.push({
          text: this.$t("_roi_cleaning_euro_optim_long_"),
          value: "roi_cleaning_euro_optim_long",
        });
        
      }

      if (
        this.btnElagage &&
        !dynamicHeaders.some((header) => header.text === "elagage")
      ) {
        
        dynamicHeaders.push({
          text: this.$t("_site_last_pruning_dates_"),
          value: "site_last_pruning_dates", // ensure this key is added if returned by your backend/query
        });
        dynamicHeaders.push({
          text: this.$t("_site_current_shading_losses_pct_"),
          value: "site_current_shading_losses_pct",
        });
        dynamicHeaders.push({
          text: this.$t("_shading_losses_compliance_"),
          value: "shading_losses_compliance",
        });
        dynamicHeaders.push({
          text: this.$t("_site_pruning_freq_initial_"),
          value: "site_pruning_freq_initial",
        });
        dynamicHeaders.push({
          text: this.$t("_site_pruning_freq_chosen_"),
          value: "site_pruning_freq_chosen",
        });
        dynamicHeaders.push({
          text: this.$t("_roi_pruning_euro_user_long_"),
          value: "roi_pruning_euro_user_long",
        });
        dynamicHeaders.push({
          text: this.$t("_site_pruning_freq_optim_"),
          value: "site_pruning_freq_optim",
        });
        dynamicHeaders.push({
          text: this.$t("_roi_pruning_euro_optim_long_"),
          value: "roi_pruning_euro_optim_long",
        });
        
      }

      return dynamicHeaders;
},

    searchstartdate(id) {
      let start_date = "";

      this.installations.forEach((element) => {
        if (element.installation_id == id) {
          start_date = element.audit_start_date;
        }
      });
      return start_date;
    },

    searchenddate(id) {
      let end_date = "";

      this.installations.forEach((element) => {
        if (element.installation_id == id) {
          end_date = element.audit_end_date;
        }
      });
      return end_date;
    },

    takeselectsites() {
      let sites = [];
      this.installations.forEach((element) => {
        let cleanName = element.installation_name.trim();
        if (this.selectsite.includes(cleanName)) {
          sites.push(element);
        }
      });
      return sites;
    },

    goToInstallation(installation) {
      let to = `/helio-clean/${installation.installation_id}?selected_date=${this.selected_date}`;
      this.$store.commit("SET_CUR_INSTALL_ID", installation.installation_id);
      this.$router.push(to);
    },
  },
};
</script>

<style scoped>
.custom-data-table {
  border-radius: 10px;
  overflow: hidden;
}

.custom-data-table .v-data-table-header {
  background-color: #e0e0e0;
}

.custom-data-table .v-data-table-header th {
  background-color: #e0e0e0;
}
</style>
